export class CargoNature {
  packageQuantity: string;
  packageType: string;
  code: string;
  codeType: string;
  agencyCode: string;
}
